import { faSearch, faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { SClearIcon, SInput, SSearchIcon, SWrapper } from '../styles/SearchBar.styled';

interface IProps {
  value: string;
  onChange: (value: string) => void;
}

const SearchBar: React.FC<IProps> = ({ value, onChange }) => {
  const [isInputFocused, setIsInputFocused] = useState(true);

  if (isInputFocused || value) {
    return (
      <SWrapper>
        <SInput
          autoFocus
          id="txtTopSearchBar"
          type="text"
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
        />
        {value && isInputFocused ? (
          <SClearIcon
            onMouseDown={(e) => {
              e.preventDefault();
              onChange('');
            }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </SClearIcon>
        ) : null}
      </SWrapper>
    );
  } else {
    return (
      <SSearchIcon id="btnCustomerSearch" onClick={() => setIsInputFocused(true)}>
        <FontAwesomeIcon icon={faSearch} />
      </SSearchIcon>
    );
  }
};

export default SearchBar;
